export default {
    report: {
        title: "Report",
        url: "/report",
    },
    user: {
        title: "Usuario",
        url: "/user",
    },
    history: {
        title: "History",
        url: "/history",
    },
    watchlist: {
        title: "Watchlist",
        url: "/watchlist",
    },
    alerts: {
        title: "Alerts",
        url: "/alerts",
    },
    wall: {
        title: "Wall",
        url: "/wall",
    },
    suscription: {
        title: "Suscription",
        url: "/suscription",
    },
    comment: {
        title: "Comment",
        url: "/comment",
    },
    profile: {
        title: "Profile",
        url: "/profile/:follower_id",
    },
    stock: {
        title: "Stock",
        url: "/stock/:ticker",
    },
    stockChart: {
        title: "Stock Chart",
        url: "/stock/:ticker/chart",
    },
    discover: {
        title: "Discover",
        url: "/discover",
    },
    calendar: {
        title: "Calendar",
        url: "/calendar",
    },
    faq: {
        title: "Faq/Release",
        url: "/faq",
    },
    knowledge: {
        title: "Knowledge",
        url: "/knowledge",
    },
    balance: {
        title: "Balance",
        url: "/balance",
    },

    ///////////////////////////////
    portfolio: {
        title: "Portfolio",
        url: "/portfolio",
    },
    account: {
        title: "Cuenta",
        url: "/account",
    },
    exit: {
        title: "Salir",
        url: "/login",
    },
    setting: {
        title: "Configuración",
        url: "/setting",
    },
    signup: {
        title: "Sign Up",
        url: "/signup",
    },
    recovery: {
        title: "Recovery password",
        url: "/recovery",
    },
    reset: {
        title: "Reset password",
        url: "/reset",
    },
    confirm: {
        title: "Confirm email",
        url: "/confirm",
    },
}